import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpResponse, HttpEventType } from '@angular/common/http';
import { of } from 'rxjs';

export const uploadInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn) => {
  if (req.url === 'saveUrl') {
    return of(
      new HttpResponse({ status: 200, body: { message: 'File uploaded' } })
    );
  }

  if (req.url === 'removeUrl') {
    return of(
      new HttpResponse({ status: 200, body: { message: 'File removed' } })
    );
  }

  return next(req);
};
